export const ENTITIES = '@@CATEGORY/ENTITIES';

export enum LIST {
  REQUEST = '@@CATEGORY/LIST/REQUEST',
  SUCCESS = '@@CATEGORY/LIST/SUCCESS',
  FAILURE = '@@CATEGORY/LIST/FAILURE'
}

export enum LIST_BY_APPLICANT {
  REQUEST = '@@CATEGORY/LIST_BY_APPLICANT/REQUEST',
  SUCCESS = '@@CATEGORY/LIST_BY_APPLICANT/SUCCESS',
  FAILURE = '@@CATEGORY/LIST_BY_APPLICANT/FAILURE'
}

export enum SINGLE {
  REQUEST = '@@CATEGORY/SINGLE/REQUEST',
  SUCCESS = '@@CATEGORY/SINGLE/SUCCESS',
  FAILURE = '@@CATEGORY/SINGLE/FAILURE'
}
